import React, { useEffect, useState } from 'react';
import { LoadingOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import Modal from 'antd/lib/modal/Modal';
import { Form, Button, Input, Skeleton, Space, message } from 'antd';
import { transformPro } from '../../shared/hooks/transfromApiData';
import { useQueryHook } from '../../shared/hooks/useQueryHook';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import { companyData } from '../../core/auth';
import { GetAllCountries, AddCountry, DeleteCountry, UpdateCountry } from '../../shared/common/graphqlQuery';
import CommonEditableTable from '../../shared/components/commonEditableTable/commonEditableTable';
const onError = (error: any, result: any) => {
    console.log(error, result);
}
let deleteId;
const columns = [
    {
        title: 'Country',
        dataIndex: 'country',
        key: 'country',
        width: '60%',
        editable: true,
        sorter: true,
    }
];
const CountryList = () => {
    const companyId = companyData().getCompanyData();

    const [Portsform] = Form.useForm();
    const PortsQuery = useQueryHook(GetAllCountries, { companyId: companyId });
    const [CountryListData, setCountryListData] = useState([]);
    const [visibleProducts, setVisibleProducts] = useState<boolean>(false);

    useEffect(() => {
        setCountryListData(transformPro(PortsQuery.data?.getAllCountries))
    }, [PortsQuery.data?.getAllCountries]);

    const onSubmittedProductName = (result: any) => {
            const newAddedData = transformPro(result.addCountry);
            const tableData = [...CountryListData];
            tableData.push(...newAddedData);
            setCountryListData([...tableData]);
            handleCancelProducts();
    }

    const onDeleteCountry = (result: any) => {
        const constData = [...CountryListData];
        const deletedIndex = constData.findIndex(eachData => eachData.key === deleteId);
        constData.splice(deletedIndex, 1);
        setCountryListData([...constData]);
        message.success(result.deleteCountry.message);
    }

    const onUpdatedProductName = (result: any) => {
        const newData = [...CountryListData];
        const index = newData.findIndex(item => result.UpdateCountry['_id'] === item.key);
        if (index > -1) {
            result.UpdateCountry.key = result.UpdateCountry['_id'];
            newData[index] = result.UpdateCountry;
            setCountryListData([...newData])
        }
    }

    const CountryMutation = useMutationHook(AddCountry, onSubmittedProductName, onError);
    const DeleteCountryMutation = useMutationHook(DeleteCountry, onDeleteCountry, onError);
    const UpdateCountryMutation = useMutationHook(UpdateCountry, onUpdatedProductName, onError);


    const showModalProducts = () => {
        setVisibleProducts(true);
    };
    const handleCancelProducts = () => {
        setVisibleProducts(false);
        Portsform.resetFields();
    };
    const onFinishProducts = (values: any) => {
        if(!CountryMutation.loading) {
            let anotherValue: any = { 
                countries: []
            }
            values.countries.map(eachCountry => {
                anotherValue.countries.push(eachCountry.country)
            })
            CountryMutation.callMutation({ variables: { countryInput: { ...anotherValue, companyId } } })
        }
    };

    const onSave = (value) => {
        if(!UpdateCountryMutation.loading) {
            UpdateCountryMutation.callMutation({ variables: { updateCountryInput: { companyId, countryId: value.key, countryName: value.country  } } })
        }
    }
    const onDelete = (value) => {
        if(!DeleteCountryMutation.loading) {
            deleteId = value.key;
            DeleteCountryMutation.callMutation({ variables: { deleteCountryInput: { companyId, countryId: value.key } } })
        }
    }
    return (

        <>
            <Button type="primary" onClick={showModalProducts} style={{ marginBottom: 10, marginTop: 10 }}>
                Add Country
            </Button>
            <Modal
                title="Add Country"
                style={{ top: 20 }}
                visible={visibleProducts}
                onCancel={handleCancelProducts}
                footer={[
                    <Button key="back" style={{ width: 75 }} onClick={handleCancelProducts}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" style={{ width: 75 }} ghost onClick={() => {
                        Portsform
                            .validateFields()
                            .then(values => {
                                onFinishProducts(values);
                            })
                            .catch(info => {
                                console.log('Validate Failed:', info);
                            });
                    }}>
                        {CountryMutation.loading ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Submit'}
                    </Button>,
                ]}>
                <Form
                    form={Portsform}
                    name="dynamic_form_nest_item" initialValues={[]}>
                    <Form.List name="countries">
                        {(fields, { add, remove }) => {
                            return (
                                <div>
                                    {fields.map(field => (
                                        <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }} align="start">
                                            <Form.Item
                                                {...field}
                                                name={[field.name, 'country']}
                                                fieldKey={[field.fieldKey, 'country']}
                                                rules={[{ required: true, whitespace: true, message: 'Missing Country' }]}
                                            >
                                                <Input autoComplete="off" placeholder="Country" />
                                            </Form.Item>
                                            <MinusCircleOutlined
                                                onClick={() => {
                                                    remove(field.name);
                                                }}
                                            />
                                        </Space>
                                    ))}
                                    <Form.Item>
                                        <Button
                                            type="dashed"
                                            onClick={() => {
                                                add();
                                            }}
                                            style={{ width: '60%' }}
                                        >
                                            <PlusOutlined /> Add field
                                        </Button>
                                    </Form.Item>
                                </div>
                            );
                        }}
                    </Form.List>
                </Form>
            </Modal>

            {PortsQuery.loading ? <Skeleton active /> :
                <CommonEditableTable
                    columns={columns}
                    tableRowdata={CountryListData}
                    onDelete={onDelete}
                    onSave={onSave}
                    customFormData={{country: '' }} />
            }
        </>

    );
}
export default CountryList